













































import { Subscription, Voucher, Event, EventJson, FormStep } from '@ssp/inscreva-sse-models';
import Multiselect from 'vue-multiselect';
import { Component, Vue } from 'vue-property-decorator';

import Loading from '@/components/base/Loading.vue';
import SubscriptionChart from '@/components/SubscriptionChart.vue';
import { sessionStore } from '@/store/session';

import ConfirmDialog from '../components/ConfirmDialog.vue';
import EmptyEventMessage from '../components/EmptyEventMessage.vue';
import SubscriptionDataTable from '../components/SubscriptionDataTable.vue';
import toast from '../components/toast';
import { ToastType } from '../components/toast/tost-type.enum';
import { subscriptionStore } from '../store/subscription';

@Component({
  components: {
    Loading,
    SubscriptionChart,
    Multiselect,
    EmptyEventMessage,
    SubscriptionDataTable,
    ConfirmDialog,
  },
})
export default class SubscriptionPage extends Vue {
  private isLoading: boolean = true;

  private subscriptions: Array<Subscription> = new Array<Subscription>();

  private subscriptionsFiltered: Array<Subscription> = new Array<Subscription>();

  private subscriptionChart!: SubscriptionChart;

  showModalRemoveSubscription = false;

  subscriptionToRemove: Subscription;

  async created() {
    await this.fetch();
  }

  mounted() {
    this.$nextTick(() => (this.subscriptionChart = this.$refs.subscriptionChart as SubscriptionChart));
  }

  get event(): Event {
    return EventJson.fromJson(sessionStore.session.event);
  }

  get eventExtraFields() {
    const { fields } = (this.event.steps[0] as FormStep).form;
    return fields.slice(2).map((field) => ({ text: field.text, key: field.name }));
  }

  async fetch() {
    this.isLoading = true;
    this.subscriptions = await subscriptionStore.list();
    this.subscriptionsFiltered = this.subscriptions;
    this.isLoading = false;
  }

  onVisualize(subscription: Subscription) {
    return this.$router.replace({ path: `subscription/${subscription._id}`, replace: true });
  }

  async onActiveStatus(subscription: Subscription) {
    subscription.active = !subscription.active;
    subscription.vouchers = subscription.vouchers.map((voucher: Voucher) => ({ ...voucher, active: !voucher.active }));
    await subscriptionStore
      .upsert(subscription)
      .then(() => toast('Inscrição modificada', ToastType.SUCESS))
      .catch(() => toast('Erro ao modificar inscrição', ToastType.ERROR))
      .finally(() => this.fetch());
    return this.updateData();
  }

  async handleRemoveSubscription(subscription: Subscription) {
    this.showModalRemoveSubscription = true;
    this.subscriptionToRemove = subscription;
  }

  async removeSubscription() {
    await subscriptionStore
      .remove(this.subscriptionToRemove._id)
      .then(() => toast('Inscrição removida', ToastType.SUCESS))
      .catch(() => toast('Erro ao remover inscrição', ToastType.ERROR))
      .finally(() => this.fetch());
    return this.updateData();
  }

  onUpdateData(subscriptionsFiltered: Array<Subscription>) {
    this.subscriptionsFiltered = subscriptionsFiltered;
    this.updateData(false);
  }

  updateData(updateLoader: boolean = true) {
    this.isLoading = updateLoader;
    if (!this.subscriptionChart && this.subscriptions?.length) {
      this.subscriptionChart = this.$refs.subscriptionChart as SubscriptionChart;
    }
    this.subscriptionChart?.onUpdate();
    this.isLoading = false;
  }
}
